// extracted by mini-css-extract-plugin
export default {"container":"tQ9ROzeqIAqJZDQ9voyO","animation":"dV552s6yLwMxRyW2XNHp","message":"BQpRipt5jftkZ3AjK0dF","pulse":"V4aAaBL9rNCQKgNdDVkd"};